import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OpsUserCategoryService {
    private domain: string;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async createMany(data: any[], vesselId) {
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/opsUserCategory`,
                { permissions: data, vesselId },
                {
                    headers: this.headers,
                }
            )
        );
    }
}
